import { render, staticRenderFns } from "./FriendswishlistView.vue?vue&type=template&id=886b1000"
import script from "./FriendswishlistView.vue?vue&type=script&lang=js"
export * from "./FriendswishlistView.vue?vue&type=script&lang=js"
import style0 from "./FriendswishlistView.vue?vue&type=style&index=0&id=886b1000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports